// extracted by mini-css-extract-plugin
export var label = "_cy-5";
export var slideContainer = "_cy-0";
export var slider = "_cy-1";
export var sliderLg = "_cy-4";
export var sliderMd = "_cy-3";
export var sliderSm = "_cy-2";